<template>
  <div class="vx-row mb-6">
    <div class="vx-col sm:w-1/6 w-full">
      <span>Description</span>
    </div>
    <div class="vx-col sm:w-5/6 w-full">
      <vs-textarea
        :disabled="disabled"
        counter="255"
        maxlength="255"
        :label="'Counter: '+parseInt(255-mutableValue.length)"
        counter-danger.sync="false"
        v-model="mutableValue"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
    obj: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mutableValue: "",
    };
  },
  mounted() {
    this.mutableValue = this.value;
  },
  watch: {
    value(val) {
      this.mutableValue = val;
    },
    mutableValue(val) {
      var obj = this.obj;
      this.$emit("data", { val, obj });
    },
  },
};
</script>